export default __webpack_public_path__ + "static/Paragraph-8a1b83c5e8870f64cb302603ebc34f2b.jpg";